/**
 * @file ItemUnitsRow.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-18
 * @modified 2026-09-25
 * @description What a quantity of an item counts in, for the read-only item
 *              detail modals — InventoryItemModal and the near-verbatim copy
 *              inside SearchInventory. Both show the same layout, so the row
 *              lives here rather than in each of them, the way
 *              CalculatedCostPanel and FormulationButton already do.
 *
 *              The row is always rendered, including when no weight is set:
 *              blank is a real state with real consequences (nothing reaches
 *              the tonnage reports), and hiding it is how 3,000-odd items came
 *              to sit unweighted without anyone seeing it.
 */

import { quantityMeansFor, qtyPerPalletLabel } from '../utils/units';

function ItemUnitsRow({ item }) {
  const { unit, perUnit, means, isSet, countsInTonnage } = quantityMeansFor(item);
  const palletQty = qtyPerPalletLabel(item);

  return (
    <div className={`detail-row item-units${isSet ? '' : ' is-unset'}`}>
      <div className="detail-group">
        <label>Units</label>
        <div className="detail-value">{unit}</div>
      </div>
      <div className="detail-group">
        <label>Weight per unit</label>
        <div className="detail-value">{perUnit}</div>
      </div>
      {/* Only when recorded. The three groups above are always rendered because
          a blank weight is a real state with real consequences — nothing
          reaches the tonnage reports. A blank qty/pallet has no such
          consequence: it is a stacking detail that simply isn't known for most
          items, so an empty row for all of them would be noise. */}
      {palletQty ? (
        <div className="detail-group">
          <label>Qty / pallet</label>
          <div className="detail-value">{palletQty}</div>
        </div>
      ) : null}
      <div className="detail-group">
        <label>Quantities count in</label>
        <div
          className={`detail-value item-units-means${countsInTonnage ? '' : ' is-untonnaged'}`}
          title="Tonnage is quantity × weight per unit ÷ 1000"
        >
          {means}
        </div>
      </div>
    </div>
  );
}

export default ItemUnitsRow;
